// Google OAuth Configuration
export const GOOGLE_OAUTH_CONFIG = {
  // Replace with your actual Google OAuth Client ID
  // You can get this from Google Cloud Console
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || 'your-google-client-id-here',
  
  // Scopes for Gmail registration
  scope: 'email profile',
  
  // Redirect URI (should match what you configure in Google Cloud Console)
  // Include the base URL to match the BrowserRouter basename
  redirectUri: `${window.location.origin}${process.env.PUBLIC_URL}/google-oauth-callback.html`,
};

// Google OAuth endpoints
export const GOOGLE_OAUTH_ENDPOINTS = {
  authorization: 'https://accounts.google.com/o/oauth2/v2/auth',
  token: 'https://oauth2.googleapis.com/token',
  userInfo: 'https://www.googleapis.com/oauth2/v2/userinfo',
};

// Helper function to generate Google OAuth URL
export const generateGoogleOAuthUrl = (): string => {
  // Validate that we have a proper client ID
  if (!GOOGLE_OAUTH_CONFIG.clientId || GOOGLE_OAUTH_CONFIG.clientId === 'your-google-client-id-here') {
    throw new Error('Google OAuth Client ID is not configured. Please set REACT_APP_GOOGLE_CLIENT_ID in your .env file.');
  }

  const params = new URLSearchParams({
    client_id: GOOGLE_OAUTH_CONFIG.clientId,
    redirect_uri: GOOGLE_OAUTH_CONFIG.redirectUri,
    response_type: 'token',
    scope: GOOGLE_OAUTH_CONFIG.scope,
    response_mode: 'fragment',
  });

  return `${GOOGLE_OAUTH_ENDPOINTS.authorization}?${params.toString()}`;
};

// Helper function to validate configuration
export const validateGoogleOAuthConfig = (): boolean => {
  return !!(GOOGLE_OAUTH_CONFIG.clientId && 
           GOOGLE_OAUTH_CONFIG.clientId !== 'your-google-client-id-here');
}; 